<template>
  <div class="d-flex switch-wrapper justify-content-between align-items-center">
    <!-- <pre>{{switchVal}}</pre> -->
    <toggle-button
      ref="custominput"
      v-model="switchVal"
      :disabled="disabled"
      :sync="true"
      :labels="{ checked: $t('engine.common.lblOn', languageEngine).toUpperCase(), unchecked: $t('engine.common.lblOff', languageEngine).toUpperCase() }"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  methods: {
    open_manage() {
      this.$bvModal.show(this.modalName);
    }
  },
  //
  computed:{
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    switchVal:{
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value, this.keyID);
        this.$emit("change", value, this.keyID);
      }
    }
  },
  props: {
    value: {
      type: [Boolean, String],
    },
    keyID: {
      default: "",
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss">
label.vue-js-switch {
  margin-bottom: 0px !important;
  & > .v-switch-core {
    box-shadow: 0px 0px 0 1px #6f7780;
    background-color: #e6e6e6 !important;
    & .v-switch-button {
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    }
  }

  & .v-switch-label {
    color: #999999 !important;
    &.v-right {
      right: 8px !important;
    }
  }
}
label.vue-js-switch.toggled {
  & > .v-switch-core {
    background-color: #67cde5 !important;
    box-shadow: 0px 0px 0 1px #329cc0;
  }
  & .v-switch-label {
    color: white !important;
  }
}
  .switch-wrapper {
    height: 22px;
    .manage { 
      display: none;
    }
    &:hover {
      .manage {
        display: block;
      }
    }
  }
</style>